module.exports = __webpack_public_path__ + "media/landing_page/why-shoppers-pp-3-166e1888.jpg";